import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b69986dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "frisbuy-marketplace-reviews__product-raiting"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Рейтинг товара", -1))
const _hoisted_4 = { class: "frisbuy-product-rating" }
const _hoisted_5 = { class: "frisbuy-product-rating__info" }
const _hoisted_6 = {
  key: 0,
  class: "frisbuy-product-rating__stars"
}
const _hoisted_7 = { class: "frisbuy-product-rating__counts" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "frisbuy-image-upload-button",
  "widget-iu-button": "true",
  onclick: "iuWidget.open()"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-image-upload-button__default-text" }, " Добавить отзыв ")
], -1))
const _hoisted_9 = {
  key: 2,
  class: "frisbuy-marketplace-reviews__customers-photos"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Фото покупателей", -1))
const _hoisted_11 = { class: "frisbuy-marketplace-reviews__customers-photos-list" }
const _hoisted_12 = {
  key: 3,
  class: "frisbuy-marketplace-reviews__summary-section"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "frisbuy-marketplace-reviews__summary-description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-marketplace-reviews__summary-title" }, " Что говорят люди "),
  /*#__PURE__*/_createElementVNode("span", { class: "frisbuy-marketplace-reviews__summary-subtitle" }, " собирательный отзыв на основе пользовательских мнений ")
], -1))
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "frisbuy-marketplace-reviews__customers-reviews" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Все отзывы", -1))
const _hoisted_17 = { class: "frisbuy-marketplace-reviews__filters" }
const _hoisted_18 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__filter frisbuy-marketplace-reviews--min-full"
}
const _hoisted_19 = { class: "frisbuy-marketplace-reviews__filter" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Показать с оценкой", -1))
const _hoisted_21 = { class: "frisbuy-marketplace-reviews__filter" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Сортировка", -1))
const _hoisted_23 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__list"
}
const _hoisted_24 = {
  key: 0,
  class: "frisbuy-marketplace-reviews__list-item"
}
const _hoisted_25 = {
  key: 1,
  class: "frisbuy-marketplace-reviews-not-found-text"
}
const _hoisted_26 = {
  key: 4,
  class: "frisbuy-marketplace-reviews__pagination"
}

import {
  computed,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  ref,
  watch,
} from "vue";
import CustomerReview from "./components/CustomerReview.vue";
import PopupReviewPost from "./components/PopupReviewPost/PopupReviewPost.vue";
import {
  imageWithPostId,
  IMarketplaceReviewsPost,
  productRating,
} from "./interfaces";
import MediaList from "./components/MediaList.vue";
import ArrowButton from "./components/ArrowButton.vue";
import PaginationPanel from "./components/Pagination/PaginationPanel.vue";
import FrSelect from "./components/FrSelect/FrSelect.vue";
import FrSegmented from "./components/FrSegmented/FrSegmented.vue";
import RatingBar, { TRating } from "./components/RatingBar/RatingBar.vue";
import Vue3StarRating from "vue3-star-ratings";
import StarRounded from "./Icons/StarRounded.vue";
import StarSoftRounded from "./Icons/StarSoftRounded.vue";
import { onMounted } from "vue";
import {
  getCustomersMediaList,
  getPostsInfo,
  TCustomersMediaList,
  TPostsFilterOptions,
} from "./api/api";
import { addSchemaToPage } from "@/common/services/SchemaOrg/SchemaOrg";
import { sendToGa4Dictionary } from "../../helpers.js";
import { sendFrisbuyAnalyticsEvent } from "@/common/services/FrisbuyAnalytics/FrisbuyAnalytics";
import widgetTypes from "@/common/consts/widgetTypes.js";

//#region Schema.org

export default /*#__PURE__*/_defineComponent({
  __name: 'MarketplaceReviews',
  props: {
    settings: {},
    mobileSettings: {},
    propPostList: {},
    lastPage: {},
    propPostCount: {},
    productRating: {},
    extraData: {}
  },
  setup(__props: any) {

onBeforeMount(() => {
  if (!props.productRating || props.productRating.reviewsCount <= 0) {
    return;
  }

  const bestRating = 5;
  // NOTE: if ratingValue === 0 and worstRating === 1, then will be error
  const worstRating = 1;
  const product = props.productRating.sku[0];

  const reviews = filteredPostList.value.map((post) => {
    const ratingValue =
      post.frisbuyPost.rating > 0 ? post.frisbuyPost.rating : bestRating;

    return {
      "@type": "Review",

      author: {
        "@type": "Person",
        name:
          post.instagramPost.authorUser.fio ||
          `@${post.instagramPost.authorUser.username}`,
      },
      datePublished: getParsedReviewDate(post),
      reviewBody: `${post.frisbuyPost.text}\n${post.frisbuyPost.positiveComment}\n${post.frisbuyPost.negativeComment}`,

      reviewRating: {
        "@type": "Rating",
        bestRating: bestRating,
        ratingValue: ratingValue,
        worstRating: worstRating,
      },
    };
  });

  const productAvgRating =
    props.productRating.avgRating > 0
      ? props.productRating.avgRating
      : bestRating;

  const SchemaorgProduct = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.name,
    image: product.thumbUrl,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: productAvgRating,
      bestRating: bestRating,
      worstRating: worstRating,
      reviewCount: props.productRating.reviewsCount,
    },
    offers: {
      "@type": "AggregateOffer",
      url: product.vendorShopUrl,
      priceCurrency: product.currencyCode,
      price: product.price,
      offerCount: props.productRating.allReviewsCount,
    },
    review: reviews,
  };

  addSchemaToPage(SchemaorgProduct);
});
//#endregion Schema.org

const props = __props;

const hadSeen = ref(false);
const inViewTimeout = ref<number | undefined>(undefined);
const had5SecInView = ref(false);

const isLastPage = computed(() => {
  return selectedPage.value === countOfPages.value;
});

const postList = ref<IMarketplaceReviewsPost[]>(props.propPostList);

const filteredPostList = computed<IMarketplaceReviewsPost[]>(() => {
  const filtered = postList.value.slice(
    (selectedPage.value - 1) * perPage,
    selectedPage.value * perPage
  );

  updateCountOfPages();

  return filtered;
});

// Product rating
const divisionByRating = computed<TRating[] | []>(() => {
  if (!props.productRating) {
    console.error("productRating not defined");

    return [];
  }

  const productRating: Array<TRating> = Object.values(
    props.productRating.divisionByRating
  ).map((value, index) => {
    return {
      label: String(index + 1),
      count: Number(value),
    };
  });

  return productRating.reverse();
});

const isSoftStarIcon = computed(() => {
  return props.settings.gallery.starIconType === "1";
});

const isHasSummary = computed(() => {
  if (!props.productRating) return false;

  return props.productRating.summary;
})

function isElementInView(element: any, isFull = false) {
  if (!element) return;

  const { top, bottom, height } = element.getBoundingClientRect();
  const { innerHeight: windowHeight } = window;

  if (isFull) {
    return (
      (height > windowHeight && bottom > 0 && bottom < windowHeight) ||
      (top > 0 && bottom < windowHeight)
    );
  } else {
    return top < windowHeight;
  }
}

function scrollHandler() {
  const InView5SecHandler = () => {
    had5SecInView.value = true;
    sendAnaliticEvent(
      "Eyesight5Sec",
      window.location.href,
      true,
      true
    );
  };

  nextTick(() => {
    const firstItem = widgetMarketplaceReviews.value?.querySelector(
      ".frisbuy-marketplace-reviews__list-item"
    );
    if (
      !had5SecInView.value &&
      isElementInView(widgetMarketplaceReviews.value, true)
    ) {
      window.clearTimeout(inViewTimeout.value);

      inViewTimeout.value = setTimeout(InView5SecHandler, 5000);
    } else {
      window.clearTimeout(inViewTimeout.value);
    }

    if (
      !hadSeen.value &&
      isElementInView(firstItem || widgetMarketplaceReviews.value, true)
    ) {
      hadSeen.value = true;
      sendAnaliticEvent("Eyesight", window.location.href, true, true);
    }
  });
}

function sendGAEvent(
  action: any,
  label: any,
  sendToClient: any,
  isNonInteraction: any
) {
  const originalAction = action;

  const { settings } = props;

  const {
    categoryPrefix,
    actionPrefix,
    trackingSkuId,
    trackingTagCode
  } = settings.analytics;
  const { analytics } = settings;
  const category = `Frisbuy_Gallery_${
    categoryPrefix + settings.customerCode
  }`;
  const labelItemPosition = [
    "fbProduct",
    "igCode",
    "slide",
    "link",
    "linklabel",
    "product",
    "variation",
    "offer",
    "index",
    "swipeType",
    "shareType",
    "queued",
    "load",
    "bundle",
    "domInject",
    "filter",
  ];
  const labelString =
    typeof label === "object"
      ? labelItemPosition.reduce((labelString, currentLabelItem) => {
          if (!Object.hasOwn(label, currentLabelItem)) return labelString;

          return (
            (labelString ? labelString + "_" : labelString) +
            currentLabelItem +
            label[currentLabelItem]
          );
        }, "")
      : label;

  if (!action.includes("ClickMainLink")) {
    action = `${action}_gallery${settings.galleryId}_embedID${
      settings.embedId + actionPrefix + trackingSkuId + trackingTagCode
    }`;
  }

  if (action.includes("FilterElastic")) {
    const { elasticFilter } = settings.analytics;

    let filterValue = 0;

    if (elasticFilter) {
      filterValue = elasticFilter.elasticTitle;
    }

    action = `FilterElastic_gallery${settings.galleryId}_embedID${
      settings.embedId
    }_filter${
      filterValue + actionPrefix + trackingSkuId + trackingTagCode
    }`;
  }

  if (
    settings.analytics?.elasticFilter &&
    !action.includes("FilterElastic")
  ) {
    const { gender, color, categoryId } = settings.analytics.elasticFilter;

    action += `_cat${categoryId}_gender${gender}_color${color}`;
  }

  if (settings.analytics?.ga.sendToGa) {
    if (settings.verbose) {
      console.log(
        `%cSend event: %c${category} %c${action} %c${labelString}`,
        "color: red; font-weight: bold",
        "color: blue",
        "color: green",
        "color: darkcyan"
      );
    }

    // GA4
    if (window.frisbuyGa4) {
      sendToGa4Dictionary(originalAction, { settings: props.settings }, label, true);
    }
  }

  if (!sendToClient) return;

  if (analytics?.gtm && analytics?.gtm.eventName) {
    const { gtm } = analytics;
    const gtmPayload = Object.assign(gtm.static || {}, {
      event: gtm.eventName,
      [gtm.eventCategory]: "Frisbuy_Gallery",
      [gtm.eventAction]: action,
      [gtm.eventLabel]: labelString,
      [gtm.eventNonInteractive]: isNonInteraction,
    });

    window.frisbuyGTM(gtmPayload);
  }

  if (analytics?.ga.sendToClient) {
    if (settings.verbose) {
      console.log(
        `${window["GoogleAnalyticsObject"]}('send', 'event', 'Frisbuy_Gallery', '${action}', '${labelString}')`
      );
    }

    if (window.frisbuyGa4) {
      sendToGa4Dictionary(originalAction, { settings: props.settings }, label);
    }
  }
}

function sendYMEvent(action: any, label: any) {
  const {
    galleryId: gallery,
    embedId: embedID,
    skuId,
    tagCode,
  } = props.settings;
  const clientCounterId = props.settings.analytics?.ym.clientCounterId;
  const conunterId = `yaCounter${clientCounterId}`;
  const ymParams = typeof label === "object" ? label : {};

  if (!clientCounterId || !window[conunterId]) {
    return;
  }

  Object.assign(ymParams, {
    gallery,
    embedID,
    widgetType: widgetTypes.MARKETPLACE_REVIEW,
  });

  if (skuId) {
    ymParams.sku = skuId;
  }

  if (tagCode) {
    ymParams.tagCode = tagCode;
  }

  if (ymParams.linklabel) {
    ymParams.linklabel = ymParams.linklabel.replace(/[^\w]+/g, "+");
  }

  window[conunterId].reachGoal(`Frisbuy${action}`, ymParams, () => {
    if (!props.settings.verbose) return;

    console.log(conunterId + ".push", `Frisbuy${action}`, ymParams);
  });
}

function sendAnaliticEvent(
  action: any,
  label: any,
  sendToClient = true,
  isNonInteraction = false
) {
  sendGAEvent(action, label, sendToClient, isNonInteraction);
  sendYMEvent(action, label);

  // [START] Frisbuy Analytics
  const frisbuyParams = {
    srcDomain: props.settings.srcDomain,

    embedId: props.settings.embedId,
    galleryId: props.settings.galleryId,
    skuId: props.settings.skuId,
    skuGroupId: props.settings.groupId,
    categoryId: props.settings.categoryId,
    tagCode: props.settings.tagCode,
    frUId: props.settings.frisbuyUID,
  };

  // TODO: check `label` on correct data
  if (typeof label === "object") {
    Object.assign(frisbuyParams, label);
  }

  sendFrisbuyAnalyticsEvent(action, frisbuyParams);
  // [END] Frisbuy Analytics
}

function getPluralizatedRatingCount() {
  if (!props.productRating) {
    return "";
  }

  const lastTwo = Math.abs(props.productRating.reviewsCount) % 100;
  const lastOne = Math.abs(props.productRating.reviewsCount) % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return "оценок";
  }

  if (lastOne === 1) {
    return "оценка";
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return "оценки";
  }

  return "оценок";
}

function getPluralizatedReviewsCount() {
  if (!props.productRating) {
    return "";
  }

  const lastTwo = Math.abs(props.productRating.allReviewsCount) % 100;
  const lastOne = Math.abs(props.productRating.allReviewsCount) % 10;

  if (lastTwo >= 11 && lastTwo <= 14) {
    return "отзывов";
  }

  if (lastOne === 1) {
    return "отзыв";
  }

  if (lastOne >= 2 && lastOne <= 4) {
    return "отзыва";
  }

  return "отзывов";
}

// Customers photo
const allCustomersMediaList = ref<Array<imageWithPostId>>([]);
const postListWithImages = ref<IMarketplaceReviewsPost[]>([]);

const customersPhotoScrollContainer = ref<HTMLElement | null>(null);

onMounted(() => {
  updateAllCustomersMediaList().then(() => {
    nextTick(() => {
      // NOTE: need for fill all visible container with posts
      loadCustomersMediaOnScroll(customersPhotoScrollContainer.value, 0.8);
    });
  });

  scrollHandler();
  window.addEventListener("scroll", scrollHandler);

  const { embedId, widgetStart } = props.settings;
  const entries = (performance && performance.getEntries()) || null;
  const times: any = {};

  if (entries) {
    if (widgetStart) {
      times.domInject = (performance.now() - widgetStart).toFixed(2);
    }

    entries.forEach((entry) => {
      if (entry.name.includes(embedId)) {
        times.queued = entry.startTime.toFixed(2);
        times.load = entry.duration.toFixed(2);
      } else if (
        entry.name.includes("www.frisbuy.ru") &&
        entry.name.includes("compiled")
      ) {
        times.bundle = entry.duration.toFixed(2);
      }
    });

    sendAnaliticEvent("TimeLoad", times, false, true);
  }

  sendAnaliticEvent("Load", window.location.href, true, true);

  if (props.settings.gallery.elasticFilter) {
    sendAnaliticEvent("FilterElastic", window.location.href, true, true);
  }
});

let customersMediaScrollPage = 1;
let loadCustomersMediaErrorsCount = 0;
let maxLoadCustomersMediaErrorsCount = 5;
let hasActiveRequest = false;
const isShowLeftScrollArrow = ref(true);
const isShowRightScrollArrow = ref(true);
async function loadCustomersMediaOnScroll(
  scrollEl: HTMLElement | null,
  scrollCoef = 1
) {
  if (hasActiveRequest || !scrollEl) {
    return;
  }

  //#region ScrollArrows visible
  isShowLeftScrollArrow.value = scrollEl.scrollLeft > 0;

  const scrollRight = scrollEl.scrollLeft + scrollEl.offsetWidth;
  isShowRightScrollArrow.value = scrollRight < scrollEl.scrollWidth;
  //#endregion ScrollArrows visible

  if (!scrollEl || customersMediaScrollPage >= maxCountOfPages) {
    console.warn(
      "returned",
      !scrollEl,
      customersMediaScrollPage,
      maxCountOfPages
    );
    return;
  }

  const scrollElScrollWidth = scrollEl.scrollWidth * scrollCoef;
  const scrollLeftPos = scrollEl.scrollLeft;
  const scrollRightPos = scrollLeftPos + scrollEl.clientWidth;

  if (
    scrollRightPos >= scrollElScrollWidth &&
    loadCustomersMediaErrorsCount < maxLoadCustomersMediaErrorsCount
  ) {
    try {
      hasActiveRequest = true;
      await updateAllCustomersMediaList();
      hasActiveRequest = false;
      customersMediaScrollPage += 1;

      // NOTE: need for fill all visible container with posts
      loadCustomersMediaOnScroll(scrollEl, scrollCoef);
    } catch (e) {
      loadCustomersMediaErrorsCount += 1;
      hasActiveRequest = false;

      if (loadCustomersMediaErrorsCount >= maxLoadCustomersMediaErrorsCount) {
        console.error("Failed to load customers media");
        return;
      } else {
        loadCustomersMediaOnScroll(scrollEl, scrollCoef);
      }
    }
  }
}

async function loadCustomersMediaOnPopupRequest() {
  customersMediaScrollPage += 1;
  await updateAllCustomersMediaList();
}

function scrollCustomersPhotos(direction: "left" | "right") {
  if (!customersPhotoScrollContainer.value) {
    console.error(
      "Ref element 'customersPhotoScrollContainer' doesn't exists'"
    );
    return;
  }

  sendAnaliticEvent(`Swipe`, window.location.href);

  const scrollCoef = direction === "left" ? -1 : 1;
  const percentOfScroll = 0.8;
  const scrolWidth =
    customersPhotoScrollContainer.value.offsetWidth * percentOfScroll;

  customersPhotoScrollContainer.value.scrollBy({
    behavior: "smooth",
    left: scrolWidth * scrollCoef,
    top: 0,
  });
}

onMounted(() => {
  changeAllCustomersMediaListItemsWidth();
  window.addEventListener("resize", changeAllCustomersMediaListItemsWidth);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", scrollHandler);
  window.removeEventListener("resize", changeAllCustomersMediaListItemsWidth);
});

let allCustomersMediaListItemsWidth = ref<string>();

function changeAllCustomersMediaListItemsWidth() {
  if (document.body.clientWidth >= 550) {
    allCustomersMediaListItemsWidth.value = "100px";
  } else {
    allCustomersMediaListItemsWidth.value = "72px";
  }
}

// Pagination and filters
const postCount = ref(props.propPostCount);
const countOfPages = ref(0);
const perPage = postList.value.length;
const maxCountOfPages = postCount.value / perPage;
onBeforeMount(() => {
  updateCountOfPages();
});

function updateCountOfPages() {
  countOfPages.value = Math.ceil(postCount.value / perPage);
}

const selectedPage = ref(1);
function selectPage(page: number) {
  selectedPage.value = page;

  sendAnaliticEvent(
    "NextPage",
    ++page,
    props.settings.analytics.sendNextPageToClient
  );

  updatePostList();

  scrollWidgetToTop();
}

const widgetMarketplaceReviews = ref<HTMLElement | null>(null);
function scrollWidgetToTop() {
  widgetMarketplaceReviews.value?.scrollIntoView({
    block: "start",
    behavior: "smooth",
  });
}

const filterSegment = ref();
const filterSort = ref();
const filterRating = ref();

// NOTE: if need clear postLIst on filter update
watch(filterRating, () => {
  postList.value = [];
});

watch([filterSegment], async () => {
  selectedPage.value = 1;

  updatePostList(undefined, true);
});

watch(
  [filterRating, filterSort],
  async ([newFilterRating], [oldFilterRating]) => {
    if (newFilterRating?.value !== oldFilterRating?.value) {
      selectedPage.value = 1;
    }

    updatePostList();
  }
);

async function updateAllCustomersMediaList() {
  const { embedId, skuId, groupId, srcDomain } = props.settings;

  try {
    const newCustomersMediaList: TCustomersMediaList =
      await getCustomersMediaList({
        embedId,
        skuId,
        groupId,
        srcDomain,
        lastPostId: allCustomersMediaList.value.at(-1)?.postId,
      });

    if (!newCustomersMediaList?.imagesWithPostId) {
      return;
    }
    const newPostsMediaList: Array<imageWithPostId> =
      newCustomersMediaList.imagesWithPostId;

    const newPostListWithImages: Array<IMarketplaceReviewsPost> =
      newCustomersMediaList.postList;

    newPostsMediaList.forEach((newMedia) => {
      const isRealyNewMedia = !allCustomersMediaList.value.find((media) => {
        return media.imageUrl === newMedia.imageUrl;
      });

      if (isRealyNewMedia) {
        allCustomersMediaList.value.push(newMedia);

        const isRealyNewPost = !postListWithImages.value.find((post) => {
          return post.instagramPost.frisbuyId === newMedia.postId;
        });

        if (isRealyNewPost) {
          const sameFullPost = newPostListWithImages.find((newPost) => {
            return newPost.instagramPost.frisbuyId === newMedia.postId;
          });

          if (sameFullPost) {
            postListWithImages.value.push(sameFullPost);
          }
        }
      }
    });
  } catch (e) {
    // TODO: add types to Error `e` to use it to message
    throw Error("Failed to get CustomersMediaList");
  }
}

async function updatePostList(
  page: number | undefined = undefined,
  isForceUpdate: boolean = false
) {
  const { embedId, skuId, groupId, srcDomain } = props.settings;
  const apiDefaults = { embedId, skuId, groupId, srcDomain };

  const pageForLoad = page || selectedPage.value;

  const filterOptions: TPostsFilterOptions = {
    page: pageForLoad,
    orgerBy: "provider_created_at",
    sort: filterSort.value?.value,
    ratingFilter: filterRating.value?.value,
    current_variant: filterSegment.value?.value,
  };

  // TODO: add request's error handler
  const postsInfo = await getPostsInfo(apiDefaults, filterOptions);
  const newPosts = postsInfo.posts;

  if (isForceUpdate) {
    postList.value = newPosts;
  }

  const pageIndex = perPage * (pageForLoad - 1);
  newPosts.forEach((post: IMarketplaceReviewsPost, idx: number) => {
    postList.value[pageIndex + idx] = post;

    const isRealyNewPost = !postListWithImages.value.find((postForFind) => {
      return (
        postForFind?.instagramPost.frisbuyId === post.instagramPost.frisbuyId
      );
    });

    if (isRealyNewPost) {
      postListWithImages.value.push(post);
    }
  });

  postCount.value = postsInfo.postCount;
}

// Posts
//#region get parsed post source
function getParsedReviewDate(post: IMarketplaceReviewsPost) {
  const postDate = new Date(post.instagramPost.createdAt);

  const year = postDate.toJSON().split("-")[0];
  const month = postDate.toJSON().split("-")[1];
  const day = postDate.toUTCString().split(" ")[1];

  const currentDate = new Date();

  let isToday =
    postDate.setHours(0, 0, 0, 0) === currentDate.setHours(0, 0, 0, 0);
  let isYesterday =
    postDate.setDate(postDate.getDate() + 1) ===
    currentDate.setDate(currentDate.getDate());

  let postDateLocale = `${day}.${month}.${year}`;

  if (isToday) {
    postDateLocale = "Сегодня";
  } else if (isYesterday) {
    postDateLocale = "Вчера";
  }

  return postDateLocale;
}
function getParsedReviewTime(post: IMarketplaceReviewsPost) {
  const postDate = new Date(post.instagramPost.createdAt);
  const time = postDate.toUTCString().split(" ")[4].slice(0, -3);

  return time;
}
//#endregion get parsed post source

// Selecting post
const selectedPost = ref<IMarketplaceReviewsPost | null>(null);
const selectedPostIndex = ref<number | null>(null);
const selectedMediaIndex = ref<number | null>(null);

function selectPost(
  postId: number,
  media?: imageWithPostId,
  isInPopup: boolean = false
) {
  if (postId < 0) {
    console.error(`postIndex is ${postId}. Expected Number (>= 0)`);
    return;
  }

  const postById = postListWithImages.value.find(
    (post) => post?.instagramPost.frisbuyId === postId
  );

  const postIndex = postListWithImages.value.findIndex(
    (post) => post?.instagramPost.frisbuyId === postId
  );

  if (!postById) {
    console.error(`postId (${postId}) not found`);
    return;
  }

  let mediaIndex = 0;
  if (media) {
    const findedMediaIndex = postById.media.findIndex((postMedia) => {
      return postMedia.imageUrl === media.imageUrl;
    });

    if (findedMediaIndex < 0) {
      console.warn(`media not found`);
    } else {
      mediaIndex = findedMediaIndex;
    }
  }

  const post = postListWithImages.value[postIndex];

  sendAnaliticEvent("ViewPic", {
    provPostId: post.instagramPost?.frisbuyId ?? post.providerPost.frisbuyId,
    fbProduct: post.frisbuyPost.id,
    igCode: post.instagramPost.shortcode,
    index: `[${mediaIndex}]`,
  });

  sendAnaliticEvent("ClickPic", {
    provPostId: post.instagramPost?.frisbuyId ?? post.providerPost.frisbuyId,
    fbProduct: post.frisbuyPost.id,
    igCode: post.instagramPost.shortcode,
  });

  selectedPost.value = postById;
  selectedPostIndex.value = postIndex;

  selectedMediaIndex.value = mediaIndex;

  if (isInPopup) {
    if (!nextPost.value) {
      updateAllCustomersMediaList();
    }
  } else {
    // NOTE: preload next page to give opprtunity select nextPost on nextPage via Popup
    const pageWithSelectedPost = Math.floor(postIndex / perPage) + 1;
    if (!isLastPage.value && postIndex === postList.value.length - 1) {
      updatePostList(pageWithSelectedPost + 1);
    }
  }

}

const prevPost = computed<IMarketplaceReviewsPost | undefined>(() => {
  if (!selectedPostIndex.value) {
    return undefined;
  }
  return postListWithImages.value[selectedPostIndex.value - 1];
});
function selectPrevPost() {
  if (!prevPost.value) {
    return;
  }

  selectPost(prevPost.value.instagramPost.frisbuyId);
}

const nextPost = computed<IMarketplaceReviewsPost | undefined>(() => {
  if (typeof selectedPostIndex.value !== "number") {
    return undefined;
  }
  return postListWithImages.value[selectedPostIndex.value + 1];
});
async function selectNextPost() {
  if (!nextPost.value) {
    return;
  }

  selectPost(nextPost.value.instagramPost.frisbuyId, undefined, true);
}

function closePopup() {
  selectedPost.value = null;
  selectedMediaIndex.value = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "widgetMarketplaceReviews",
      ref: widgetMarketplaceReviews,
      class: "frisbuy-marketplace-reviews"
    }, [
      (props.settings.gallery.header.html)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: props.settings.gallery.header.html
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      (props.productRating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(RatingBar, {
                divisionByRating: divisionByRating.value,
                isSoftStarIcon: isSoftStarIcon.value
              }, null, 8, ["divisionByRating", "isSoftStarIcon"]),
              _createElementVNode("div", _hoisted_5, [
                (props.productRating?.avgRating)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_unref(Vue3StarRating), {
                        modelValue: props.productRating.avgRating,
                        numberOfStars: 5,
                        starSize: 22,
                        starColor: '#606266',
                        inactiveColor: '#E9E9EB',
                        disableClick: true,
                        customSvg: isSoftStarIcon.value ? StarSoftRounded : StarRounded
                      }, null, 8, ["modelValue", "customSvg"]),
                      _createElementVNode("span", null, _toDisplayString(props.productRating.avgRating), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(props.productRating.reviewsCount) + " " + _toDisplayString(getPluralizatedRatingCount()), 1),
                  _createElementVNode("span", null, _toDisplayString(props.productRating.allReviewsCount) + " " + _toDisplayString(getPluralizatedReviewsCount()), 1)
                ])
              ]),
              _hoisted_8
            ])
          ]))
        : _createCommentVNode("", true),
      (allCustomersMediaList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createVNode(ArrowButton, {
              customClass: "frisbuy-marketplace-reviews__customers-photos-button",
              direction: "left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollCustomersPhotos('left')))
            }, null, 512), [
              [_vShow, isShowLeftScrollArrow.value]
            ]),
            _createElementVNode("div", {
              class: "frisbuy-marketplace-reviews__customers-photos-scroll-container",
              ref_key: "customersPhotoScrollContainer",
              ref: customersPhotoScrollContainer,
              onScroll: _cache[2] || (_cache[2] = 
          () => loadCustomersMediaOnScroll(customersPhotoScrollContainer.value, 0.8)
        )
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(MediaList, {
                  mediaList: allCustomersMediaList.value,
                  mediaWidth: _unref(allCustomersMediaListItemsWidth),
                  onSelectMedia: _cache[1] || (_cache[1] = (media) => selectPost(media.postId, media))
                }, null, 8, ["mediaList", "mediaWidth"])
              ])
            ], 544),
            _withDirectives(_createVNode(ArrowButton, {
              customClass: "frisbuy-marketplace-reviews__customers-photos-button",
              direction: "right",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollCustomersPhotos('right')))
            }, null, 512), [
              [_vShow, isShowRightScrollArrow.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (isHasSummary.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", {
              class: "frisbuy-marketplace-reviews__summary-text",
              innerHTML: props.productRating?.summary?.text || ''
            }, null, 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (props.extraData?.currentVariantPostsCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(FrSegmented, {
                  modelValue: filterSegment.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterSegment).value = $event)),
                  options: [
              { label: 'Все отзывы', value: 'false' },
              { label: `Этот вариант товара (${ props.extraData.currentVariantPostsCount || 0 })`, value: 'true' },
            ],
                  defaultOption: { label: 'Все отзывы', value: 'false' }
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(FrSelect, {
              modelValue: filterRating.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterRating).value = $event)),
              options: [
              { value: undefined, text: 'Все' },
              { value: 5, text: '5 звезд' },
              { value: 4, text: '4 звезды' },
              { value: 3, text: '3 звезды' },
              { value: 2, text: '2 звезды' },
              { value: 1, text: '1 звезда' },
            ],
              defaultOption: { value: 0, text: 'Все' }
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(FrSelect, {
              modelValue: filterSort.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterSort).value = $event)),
              options: [
              { value: 'desc', text: 'Сначала новые' },
              { value: 'asc', text: 'Сначала старые' },
            ],
              defaultOption: { value: 'desc', text: 'Сначала новые' }
            }, null, 8, ["modelValue"])
          ])
        ]),
        (filteredPostList.value.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPostList.value, (post, postIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: postIndex }, [
                  post
                    ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                        _createVNode(CustomerReview, {
                          customerName: 
                post.instagramPost.authorUser.fio ||
                `@${post.instagramPost.authorUser.username}`
              ,
                          reviewDate: getParsedReviewDate(post),
                          reviewTime: getParsedReviewTime(post),
                          reviewMarketplace: post.frisbuyPost.marketplaceName,
                          rating: post.frisbuyPost.rating,
                          mediaList: post.media,
                          isShowMedia: post.instagramPost.hasMedia,
                          negativeComment: post.frisbuyPost.negativeComment,
                          positiveComment: post.frisbuyPost.positiveComment,
                          text: post.frisbuyPost.text,
                          isSoftStarIcon: isSoftStarIcon.value,
                          onSelectMedia: 
                (media) => selectPost(post.instagramPost.frisbuyId, media)
              
                        }, null, 8, ["customerName", "reviewDate", "reviewTime", "reviewMarketplace", "rating", "mediaList", "isShowMedia", "negativeComment", "positiveComment", "text", "isSoftStarIcon", "onSelectMedia"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_25, " Отзывы по выбранным фильтрам не найдены "))
      ]),
      (countOfPages.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createVNode(PaginationPanel, {
              countOfPages: countOfPages.value,
              selectedPage: selectedPage.value,
              onSelectPage: _cache[7] || (_cache[7] = (page) => selectPage(page))
            }, null, 8, ["countOfPages", "selectedPage"])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (selectedPost.value && selectedMediaIndex.value !== null)
      ? (_openBlock(), _createBlock(PopupReviewPost, {
          key: 0,
          post: selectedPost.value,
          selectedMediaIndex: selectedMediaIndex.value,
          showLeftArrow: Boolean(prevPost.value),
          showRightArrow: Boolean(nextPost.value),
          settings: props.settings,
          allCustomersMediaList: allCustomersMediaList.value,
          reviewDate: getParsedReviewDate(selectedPost.value),
          reviewTime: getParsedReviewTime(selectedPost.value),
          reviewMarketplace: selectedPost.value.frisbuyPost.marketplaceName,
          onSendAnaliticEvent: _cache[8] || (_cache[8] = (event, params) => sendAnaliticEvent(event, params)),
          onSelectPrevPost: selectPrevPost,
          onSelectNextPost: selectNextPost,
          onSelectPost: _cache[9] || (_cache[9] = (postId, media) => selectPost(postId, media)),
          onRequestToLoadCustomersMedia: _cache[10] || (_cache[10] = () => loadCustomersMediaOnPopupRequest()),
          onClose: closePopup
        }, null, 8, ["post", "selectedMediaIndex", "showLeftArrow", "showRightArrow", "settings", "allCustomersMediaList", "reviewDate", "reviewTime", "reviewMarketplace"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})